<p-dialog
  (onHide)="closeDialog()"
  [dismissableMask]="false"
  position="top"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayDialog"
  [responsive]="true"
  showEffect="fade"
  [modal]="true"
  [breakpoint]="640"
  [style]="{'width':'1200px'}"
>

  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-mail-bulk mg-r-5"></i>Historique des mails
    </div>
  </ng-template>

  <p-scrollPanel [style]="getScrollPanelStyle()">

    <dx-data-grid
      [dataSource]="mails"
      keyExpr="id"
      width="100%"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      [showBorders]="true"
      #grid>
      <dxi-column dataField="statut" width="180" caption="Etat" cellTemplate="templateStatut"
                  alignement="left"></dxi-column>
      <dxi-column dataField="emitterNom" caption="Emetteur" cellTemplate="templateEmitterNom"
                  alignement="left"></dxi-column>
      <dxi-column dataField="receiver" caption="Destinataire" cellTemplate="templateReceiver"
                  alignement="left"></dxi-column>
      <dxi-column dataField="sentDate" width="150" caption="Date d'envoi" cellTemplate="templateSentDate"
                  alignement="left"></dxi-column>
      <dxi-column dataField="readDate" width="150" caption="Date de lecture" cellTemplate="templateReadDate"
                  alignement="left"></dxi-column>
      <dxi-column dataField="erreur" width="150" caption="Statut du mail" cellTemplate="templateErreur"
                  alignement="left"></dxi-column>

      <div *dxTemplate="let cell of 'templateSentDate'">
        {{cell.row.data.sentDate  | date:'dd/MM/yyyy HH:mm:ss'}}
      </div>

      <div *dxTemplate="let cell of 'templateReadDate'">
        <ng-container *ngIf="cell.row.data.readDate">
          {{cell.row.data.readDate  | date:'dd/MM/yyyy HH:mm:ss'}}
        </ng-container>
      </div>

      <div *dxTemplate="let cell of 'templateStatut'" class="text-center">
        <label class="badge mg-r-5 font-14 cursor {{this.emailHistoSvc.getEmailStatutBadge(cell.row.data.statut)}}">
          {{emailHistoSvc.getLabelStatut(cell.row.data.statut)}}
        </label>
      </div>

      <div *dxTemplate="let cell of 'templateEmitterNom'" class="wrap-text">
        {{cell.row.data.emitterNom | titlecase}}{{(cell.row.data.emitterPrenom ? " " + cell.row.data.emitterPrenom : "") | titlecase}}
        - {{cell.row.data.emitterEmail | lowercase}}
      </div>

      <div *dxTemplate="let cell of 'templateReceiver'" class="wrap-text">
        {{cell.row.data.receiver | titlecase}}{{(cell.row.data.receiverEmail ? " - " + cell.row.data.receiverEmail : "") | lowercase}}
      </div>

      <div *dxTemplate="let cell of 'templateErreur'">
        <ng-container *ngIf="utils.isNullOrEmpty(cell.row.data.erreur)">
          <yo-check [checked]="true"></yo-check>
          Aucune erreur
        </ng-container>
        <ng-container *ngIf="!utils.isNullOrEmpty(cell.row.data.erreur)">
          <yo-check [checked]="false"></yo-check>
          {{cell.row.data.erreur}}
        </ng-container>
      </div>

    </dx-data-grid>

  </p-scrollPanel>

  <!--  FOOTER-->
  <ng-template pTemplate="footer">

    <!--    BOUTONS D'ACTIONS-->
    <ng-container *ngTemplateOutlet="tplActionButtons"></ng-container>

  </ng-template>

</p-dialog>

<!--TEMPLATE DES BOUTONS D'ACTION-->
<ng-template #tplActionButtons>
  <yo-button
    iconClass="fas fa-times"
    [theme]="ButtonThemeEnum.CANCEL" (onClick)="closeDialog()" tooltip="Fermer"></yo-button>
</ng-template>
